export class TimeModel {
    hour: number;
    minute: number;
}